function escapeHtml(value = '') {
    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

function escapeAttr(value = '') {
    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}

function isExternalUrl(url = '') {
    return /^https?:\/\//i.test(url.trim());
}

/**
 * Converts link shortcodes in the form [Label|https://example.com]
 * into real <a> links. Preserves existing HTML by operating on text nodes.
 */
export function replaceLinkShortcodes(input = '') {
    if (!input || typeof input !== 'string') return input || '';

    const pattern = /\[([^\]|]+)\|([^\]]+)\]/g;

    if (typeof document === 'undefined') {
        return input.replace(pattern, (_match, label, url) => {
            const safeLabel = escapeHtml(label.trim());
            const safeUrl = escapeAttr(url.trim());
            if (!safeLabel || !safeUrl) return _match;
            const attrs = isExternalUrl(safeUrl)
                ? ' target="_blank" rel="noopener noreferrer"'
                : '';
            return `<a href="${safeUrl}"${attrs}>${safeLabel}</a>`;
        });
    }

    const container = document.createElement('div');
    container.innerHTML = input;

    const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, null);
    const textNodes = [];
    while (walker.nextNode()) {
        textNodes.push(walker.currentNode);
    }

    textNodes.forEach(node => {
        const text = node.nodeValue || '';
        if (!pattern.test(text)) {
            pattern.lastIndex = 0;
            return;
        }
        pattern.lastIndex = 0;

        const fragment = document.createDocumentFragment();
        let lastIndex = 0;
        let match;
        while ((match = pattern.exec(text)) !== null) {
            const [fullMatch, label, url] = match;
            const start = match.index;
            const end = start + fullMatch.length;

            if (start > lastIndex) {
                fragment.appendChild(document.createTextNode(text.slice(lastIndex, start)));
            }

            const cleanLabel = (label || '').trim();
            const cleanUrl = (url || '').trim();
            if (cleanLabel && cleanUrl) {
                const link = document.createElement('a');
                link.href = cleanUrl;
                link.textContent = cleanLabel;
                if (isExternalUrl(cleanUrl)) {
                    link.target = '_blank';
                    link.rel = 'noopener noreferrer';
                }
                fragment.appendChild(link);
            } else {
                fragment.appendChild(document.createTextNode(fullMatch));
            }

            lastIndex = end;
        }

        if (lastIndex < text.length) {
            fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
        }

        node.parentNode.replaceChild(fragment, node);
    });

    return container.innerHTML;
}